import { HttpClient, provideHttpClient } from '@angular/common/http';
import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { provideFirebaseApp } from '@angular/fire/app';
import { FirebaseApp } from '@angular/fire/app';
import { getAuth } from '@angular/fire/auth';
import { provideAuth } from '@angular/fire/auth';
import { provideDatabase } from '@angular/fire/database';
import { getDatabase } from '@angular/fire/database';
import { provideFirestore } from '@angular/fire/firestore';
import { getFirestore } from '@angular/fire/firestore';
import { provideStorage } from '@angular/fire/storage';
import { getStorage } from '@angular/fire/storage';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';
import { SimpleLocalizeHttpLoaderService } from '@contler/translate/services';
import { getActualLan } from '@contler/translate/utils';
import { ASSISTANTS_URL, API_URL, MENU_UPLOADER_URL, API_RESERVATION_URL } from '@contler/utils';
import { provideStore } from '@ngrx/store';
import { TranslateModule } from '@ngx-translate/core';
import { TranslateLoader } from '@ngx-translate/core';
import { initializeApp } from 'firebase/app';

import { environment } from '../environments/environment';

import { appRoutes } from './app.routes';

export function HttpLoaderFactory(http: HttpClient) {
  return new SimpleLocalizeHttpLoaderService(http, 'onboarding');
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(appRoutes),
    provideStore(),
    provideHttpClient(),
    importProvidersFrom(
      TranslateModule.forRoot({
        loader: { provide: TranslateLoader, useFactory: HttpLoaderFactory, deps: [HttpClient] },
        defaultLanguage: getActualLan().replace('-', '_'),
        useDefaultLang: true,
      }),
    ),
    { provide: API_URL, useValue: environment.apiUrl },
    {
      provide: ASSISTANTS_URL,
      useValue: environment.assistantUrl,
    },
    {
      provide: MENU_UPLOADER_URL,
      useValue: '',
    },
    {
      provide: API_RESERVATION_URL,
      useValue: environment.apiReservation,
    },
    provideFirebaseApp(() => initializeApp(environment.firebase)),
    provideAuth((injector) => {
      const app = injector.get(FirebaseApp);
      const auth = getAuth(app);
      return auth;
    }),
    provideFirestore((injector) => {
      const app = injector.get(FirebaseApp);
      const firestore = getFirestore(app);
      return firestore;
    }),
    provideDatabase((injector) => {
      const app = injector.get(FirebaseApp);
      const database = getDatabase(app);
      return database;
    }),
    provideStorage((injector) => {
      const app = injector.get(FirebaseApp);
      const storage = getStorage(app);
      return storage;
    }),
    provideAnimations(),
  ],
};
